import WebSocketImport from 'ws';

export default (() => {
  if (global.WebSocket) {
    return global.WebSocket;
  }

  return WebSocketImport;
})();
